/* eslint-disable consistent-return */
/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Divider,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import * as Sentry from "@sentry/react";
import Tooltip from "@mui/material/Tooltip";
import { useLocation, useNavigate } from "react-router-dom";
import EyeIcon from "../../../../assets/svg/Eye";
import { AlertStatus, PERMISSIONS } from "../../../../contants";
import useUserConfig from "../../../../hooks/useUserConfig";
import { fetchFriendTransferData } from "../../../../redux/actions/friend";
import { fetchIntroductionData } from "../../../../redux/actions/introduction";
import { fetchMemberTransferData } from "../../../../redux/actions/member";
import {
  selectAllSIUsers,
  selectDistrictSiUser,
  selectUserProfile,
} from "../../../../redux/selectors/user";
import { convertDateTimeToDate } from "../../../../utils/dateAndTime";
import { hasPermissionForAction, notNull } from "../../../../utils/helper";
import Toast from "../../Toast";
import AcceptModal from "../Modals/AcceptModal/AcceptModal";
import ForwardModal from "../Modals/ForwardModal/ForwardModal";
import RejectModal from "../Modals/RejectModal/RejectModal";
import TransferForm from "../ViewTranfer/TransferForm";
import styles, { tabelCellWidth } from "./AccordianTable.styles";
import { COLUMNS } from "./constant";
import Button from "../../Button";
import IntroductionForm from "../../../../services/api/introductionForm";
import Alert from "../Alert/Alert";
import Friends from "../../../../services/api/friend";
import Member from "../../../../services/api/member";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import AlertForMobile from "../Alert/AlertForMobile";

const INITIATED = "initiated";
const BELOW_STRUCTURE = "belowStructure";

const showAssignLogic = (userInfo, targetOrganizationStructure) => {
  if (userInfo.areaSi) {
    return (
      userInfo?.areaId &&
      userInfo?.areaId === targetOrganizationStructure?.targetOrgAreaId &&
      !targetOrganizationStructure?.targetOrgZoneId &&
      !targetOrganizationStructure?.targetOrgRegionId &&
      !targetOrganizationStructure?.targetOrgChapterId &&
      !targetOrganizationStructure?.targetOrgDistrictId
    );
  }
  if (userInfo.zoneSi) {
    return (
      userInfo?.zoneId &&
      userInfo?.zoneId === targetOrganizationStructure?.targetOrgZoneId &&
      !targetOrganizationStructure?.targetOrgRegionId &&
      !targetOrganizationStructure?.targetOrgChapterId &&
      !targetOrganizationStructure?.targetOrgDistrictId
    );
  }
  if (userInfo.regionSi) {
    return (
      userInfo?.regionId &&
      userInfo?.regionId === targetOrganizationStructure?.targetOrgRegionId &&
      !targetOrganizationStructure?.targetOrgChapterId &&
      !targetOrganizationStructure?.targetOrgDistrictId
    );
  }
  if (userInfo.chapterSi) {
    return (
      userInfo?.chapterId &&
      userInfo?.chapterId === targetOrganizationStructure?.targetOrgChapterId &&
      !targetOrganizationStructure?.targetOrgDistrictId
    );
  }
  return false;
};

function Row({
  rowData,
  onCancel,
  cameFromFriendTransfer,
  cameFromMemberTransfer,
  onReject,
  onForward,
  onAccept,
  onSelectTransfer,
}) {
  const [openMakeNewFriendDialog, setOpenMakeNewFriendDialog] = useState(false);

  const districtSi = useSelector(selectDistrictSiUser);
  const { isHelpDesk, isHelpDeskAdmin, isDistrictSi } =
    useSelector(selectAllSIUsers);
  const user = useSelector(selectUserProfile);
  const hasPermission = useUserConfig();
  const transferType = useSelector(
    (state) => state.dashboard.transferPendingType
  );
  const location = useLocation();
  const isOutOfTheStructure = transferType === INITIATED;
  const isBelowStructure = transferType === BELOW_STRUCTURE;
  const navigate = useNavigate();

  const showForward = () => {
    if (isHelpDesk || isHelpDeskAdmin) {
      return true;
    }

    if (cameFromFriendTransfer) {
      return (
        !isOutOfTheStructure &&
        hasPermission(PERMISSIONS.ASSIGN_TO_NEXT_LEVEL_FRIEND) &&
        showAssignLogic(user, rowData?.targetOrganizationStructure)
      );
    }
    if (cameFromMemberTransfer) {
      return (
        !isOutOfTheStructure &&
        hasPermission(PERMISSIONS.ASSIGN_TO_NEXT_LEVEL_MEMBER) &&
        showAssignLogic(user, rowData?.targetOrganizationStructure)
      );
    }
    return (
      !isOutOfTheStructure &&
      hasPermission(PERMISSIONS.ASSIGN_TO_NEXT_LEVEL_INTRODUCTION) &&
      hasPermissionForAction(rowData)
    );
  };

  const showReject = () => {
    if (cameFromFriendTransfer) {
      return (
        !isOutOfTheStructure &&
        hasPermission(PERMISSIONS.REJECT_FRIEND) &&
        districtSi &&
        user?.districtId ===
          rowData?.targetOrganizationStructure?.targetOrgDistrictId
      );
    }
    if (cameFromMemberTransfer) {
      return (
        !isOutOfTheStructure &&
        !isBelowStructure &&
        districtSi &&
        hasPermission(PERMISSIONS.REJECT_TRANSFER_MEMBER)
      );
    }
    return (
      !isOutOfTheStructure &&
      hasPermission(PERMISSIONS.REJECT_INTRODUCTION) &&
      hasPermissionForAction(rowData) &&
      districtSi
    );
  };

  const showAccept = () => {
    const targetDistrictId =
      rowData?.targetOrganizationStructure?.targetOrgDistrictId;
    const userDistrictId = user?.districtId;

    if (cameFromMemberTransfer) {
      return !isOutOfTheStructure && districtSi;
    }

    return (
      !isOutOfTheStructure &&
      cameFromFriendTransfer &&
      hasPermission(PERMISSIONS.FINAL_ACCEPT_FRIEND) &&
      districtSi &&
      targetDistrictId === userDistrictId
    );
  };

  const showCancel = () => {
    const oldOrgDistrictDtoId =
      rowData?.oldOrganizationStructureDto?.oldOrgDistrictId;
    const oldOrgDistrictId =
      rowData?.oldOrganizationStructure?.oldOrgDistrictId;
    const userDistrictId = user?.districtId;
    const hasDistrictSI = user?.assignedRoles?.includes("districtSI");

    const isMatchingDistrict =
      oldOrgDistrictId === userDistrictId ||
      oldOrgDistrictDtoId === userDistrictId;
    if (
      isHelpDesk ||
      isHelpDeskAdmin ||
      (isMatchingDistrict && hasDistrictSI)
    ) {
      return true;
    }

    const { districtId } = user;
    const { initiatorMember } = rowData;

    return initiatorMember !== null
      ? isOutOfTheStructure &&
          districtSi &&
          initiatorMember?.districtId === districtId
      : null;
  };

  const showMakeNewFriend = () => {
    return (
      location.pathname.includes("/introduction/view") &&
      isDistrictSi &&
      transferType === "assignedToMe"
    );
  };

  const handleMakeNewFriendClick = () => {
    setOpenMakeNewFriendDialog(true);
  };

  const handleMakeNewFriendProceed = () => {
    setOpenMakeNewFriendDialog(false);
    navigate(`/new-friend/change/${rowData.introductionId}`, {
      state: {
        fromIntroductionView: true,
        selectedIntroduction: rowData,
        defaultMeetingType: "DISCUSSION_MEETING",
      },
    });
  };

  const targetSiList = rowData?.targetSiDetails.length;
  console.log("list", targetSiList);
  const initiatorSiList = rowData?.initiatorSiDetails?.length;

  return (
    <>
      <TableRow>
        {(cameFromFriendTransfer || cameFromMemberTransfer) && (
          <TableCell
            style={{
              ...styles.blueTableCell,
              ...tabelCellWidth.medium,
            }}
          >
            {(cameFromFriendTransfer && rowData.friendId) ||
              (cameFromMemberTransfer &&
                rowData.memberId &&
                notNull(rowData.friendId || rowData.memberId))}
          </TableCell>
        )}
        <TableCell
          style={{
            ...styles.greyTableCell,
            ...tabelCellWidth.medium,
          }}
        >
          {notNull(rowData.fullName)} <br />
          {notNull(rowData.mobileNumber)} <br />
          <Typography
            variant="small"
            style={{ ...styles.text, lineHeight: "17px" }}
          >
            {notNull(rowData.emailId)}
          </Typography>
        </TableCell>
        <TableCell
          style={{
            ...styles.blueTableCell,
            ...tabelCellWidth.medium,
            padding: "16px 0px 10px 30px",
          }}
        >
          {notNull(rowData.divisionName)}
        </TableCell>
        <TableCell
          style={{
            ...styles.blueTableCell,
            ...tabelCellWidth.medium,
          }}
        >
          <Typography
            variant="small"
            style={{ ...styles.largeText, lineHeight: "17px" }}
          >
            {notNull(
              rowData?.oldOrganizationStructureDto?.oldAddress ||
                rowData?.addressLine1
            )}{" "}
          </Typography>
          <br />
          {cameFromFriendTransfer || cameFromMemberTransfer
            ? [
                rowData?.oldOrganizationStructureDto?.oldOrgArea ||
                  rowData?.targetOrganizationStructure?.targetOrgArea,
                rowData?.oldOrganizationStructureDto?.oldOrgZone ||
                  rowData?.targetOrganizationStructure?.targetOrgZone,
                rowData?.oldOrganizationStructureDto?.oldOrgRegion ||
                  rowData?.targetOrganizationStructure?.targetOrgRegion,
                rowData?.oldOrganizationStructureDto?.oldOrgChapter ||
                  rowData?.targetOrganizationStructure?.targetOrgChapter,
                rowData?.oldOrganizationStructureDto?.oldOrgDistrict ||
                  rowData?.targetOrganizationStructure?.targetOrgDistrict,
              ]
                .filter(Boolean)
                .join("/ ")
            : [
                rowData?.oldOrganizationStructure?.oldOrgArea,
                rowData?.oldOrganizationStructure?.oldOrgZone,
                rowData?.oldOrganizationStructure?.oldOrgRegion,
                rowData?.oldOrganizationStructure?.oldOrgChapter,
                rowData?.oldOrganizationStructure?.oldOrgDistrict,
              ]
                .filter(Boolean)
                .join("/ ")}
        </TableCell>

        <TableCell
          style={{
            ...styles.blueTableCell,
            ...tabelCellWidth.large,
          }}
        >
          {initiatorSiList === 0 ? (
            "NA"
          ) : initiatorSiList <= 2 ? (
            rowData?.initiatorSiDetails?.map((SiNames, index) => (
              <div key={index}>
                {SiNames?.initiatorSiName}
                <br />
                {SiNames?.initiatorSiMobileNumber}
                <br />
                {SiNames?.initiatorSiEmail}
                {index < initiatorSiList - 1 && <hr />}
              </div>
            ))
          ) : (
            <Tooltip
              title={rowData?.initiatorSiDetails?.map((SiNames, index) => (
                <div key={index}>
                  {SiNames?.initiatorSiName}
                  <br />
                  {SiNames?.initiatorSiMobileNumber}
                  <br />
                  {SiNames?.initiatorSiEmail}
                  {index < initiatorSiList - 1 && <hr />}
                </div>
              ))}
            >
              <div>
                {rowData?.initiatorSiDetails
                  ?.slice(0, 2)
                  .map((SiNames, index) => (
                    <div key={index}>
                      {SiNames?.initiatorSiName}
                      <br />
                      {SiNames?.initiatorSiMobileNumber}
                      <br />
                      {SiNames?.initiatorSiEmail}
                      {index < 1 && <hr />}
                    </div>
                  ))}
              </div>
            </Tooltip>
          )}
        </TableCell>

        <TableCell
          style={{
            padding: "10px 0px 0px 0px",
            height: "6rem",
          }}
        >
          <Divider orientation="vertical" />
        </TableCell>
        <TableCell
          style={{
            ...styles.blueTableCell,
            ...tabelCellWidth.medium,
          }}
        >
          {notNull(rowData.addressLine1) || "-"} <br /> <br />
          {[
            rowData?.targetOrganizationStructure?.targetOrgArea,
            rowData?.targetOrganizationStructure?.targetOrgZone,
            rowData?.targetOrganizationStructure?.targetOrgRegion,
            rowData?.targetOrganizationStructure?.targetOrgChapter,
            rowData?.targetOrganizationStructure?.targetOrgDistrict,
          ]
            .filter(Boolean)
            .join("/ ")}
        </TableCell>

        <TableCell
          style={{
            ...styles.blueTableCell,
            ...tabelCellWidth.large,
          }}
        >
          {targetSiList === 0 ? (
            "NA"
          ) : targetSiList <= 2 ? (
            rowData?.targetSiDetails?.map((SiNames, index) => (
              <div key={index}>
                {SiNames?.targetSiName}
                <br />
                {SiNames?.targetSiMobileNumber}
                <br />
                {SiNames?.targetSiEmail}
                {index < targetSiList - 1 && <hr />}
              </div>
            ))
          ) : (
            <Tooltip
              title={rowData?.targetSiDetails?.map((SiNames, index) => (
                <div key={index}>
                  {SiNames?.targetSiName}
                  <br />
                  {SiNames?.targetSiMobileNumber}
                  <br />
                  {SiNames?.targetSiEmail}
                  {index < targetSiList - 1 && <hr />}
                </div>
              ))}
            >
              <div>
                {rowData?.targetSiDetails?.slice(0, 2).map((SiNames, index) => (
                  <div key={index}>
                    {SiNames?.targetSiName}
                    <br />
                    {SiNames?.targetSiMobileNumber}
                    <br />
                    {SiNames?.targetSiEmail}
                    {index < 1 && <hr />}
                  </div>
                ))}
              </div>
            </Tooltip>
          )}
        </TableCell>
        <TableCell
          style={{
            ...styles.blueTableCell,
            ...tabelCellWidth.medium,
          }}
        >
          {convertDateTimeToDate(rowData.updatedAt)} <br /> <br />
          {rowData.introducedByName}
          <br />
          {rowData.introducedByMobileNumber}
        </TableCell>
        <TableCell
          style={{
            ...tabelCellWidth.medium,
          }}
        >
          <Box variant="flex">
            <Box style={styles.eyeIcon}>
              <EyeIcon
                style={{ color: "#8f92a1cc", marginBottom: "8px" }}
                onClick={() => onSelectTransfer(rowData)}
              />
            </Box>
            {showForward() && (
              <Button
                variant="contained"
                label="ASSIGN"
                style={{ ...styles.actionBtn, marginBottom: "10px" }}
                onClick={() => onForward(rowData)}
              >
                ASSIGN
              </Button>
            )}
            {showAccept() && (
              <Button
                variant="contained"
                label="ACCEPT"
                style={{ ...styles.actionBtn, marginBottom: "10px" }}
                onClick={() => {
                  onAccept(rowData);
                }}
              >
                ACCEPT
              </Button>
            )}
            {showReject() && (
              <Button
                variant="outlined"
                label="REJECT"
                style={{ ...styles.actionBtn, marginBottom: "10px" }}
                onClick={() => onReject(rowData)}
              >
                {" "}
                REJECT
              </Button>
            )}
            {showCancel() && (
              <Button
                variant="outlined"
                label="CANCEL"
                style={{ ...styles.actionBtn, marginBottom: "10px" }}
                onClick={() => {
                  onCancel(rowData);
                }}
              >
                CANCEL
              </Button>
            )}
            {showMakeNewFriend() && (
              <Button
                variant="contained"
                label="MAKE NEW FRIEND"
                style={{
                  ...styles.actionBtn,
                  marginBottom: "10px",
                  height: "40px",
                }}
                onClick={handleMakeNewFriendClick}
              >
                MAKE NEW FRIEND
              </Button>
            )}
          </Box>
        </TableCell>
      </TableRow>

      {/* Confirmation Dialog for Make New Friend */}
      <Dialog
        open={openMakeNewFriendDialog}
        onClose={() => setOpenMakeNewFriendDialog(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            minWidth: "400px",
            maxWidth: "500px",
            padding: "24px",
            textAlign: "center",
          },
        }}
      >
        {/* Warning Icon */}
        <Box sx={{ mb: 3 }}>
          <Box
            sx={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              border: "3px solid #f39c12",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto",
              backgroundColor: "white",
            }}
          >
            <Typography
              sx={{
                fontSize: "36px",
                color: "#f39c12",
                fontWeight: "bold",
                lineHeight: 1,
              }}
            >
              !
            </Typography>
          </Box>
        </Box>

        <DialogTitle
          sx={{
            fontSize: "22px",
            fontWeight: 500,
            color: "#696464",
            mb: 2,
            p: 0,
          }}
        >
          Are you sure?
        </DialogTitle>

        <DialogContent sx={{ p: 0, mb: 4 }}>
          <Typography
            sx={{
              color: "#666",
              fontWeight: 500,
              fontSize: "16px",
              marginBottom: "16px",
            }}
          >
            This step will add this introduction as a New Friend to discussion
            meeting of your district, for which they need to attend a BSG
            Meeting first.
          </Typography>

          <Typography
            sx={{
              color: "#666",
              fontWeight: 500,
              fontSize: "16px",
              marginBottom: "16px",
            }}
          >
            Please note irrespective of the meeting they have attended, their
            attendance for this month will get marked under Discussion Meeting
            Module.
          </Typography>

          <Typography sx={{ color: "#666", fontWeight: 500, fontSize: "16px" }}>
            Are you sure they have attended a BSG Meeting and you wish to add
            them in the district?
          </Typography>
        </DialogContent>

        <DialogActions sx={{ p: 0, gap: 2, justifyContent: "center" }}>
          <Button
            variant="contained"
            label="Proceed"
            onClick={handleMakeNewFriendProceed}
            sx={{
              backgroundColor: "#28a745",
              color: "white",
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "16px",
              fontWeight: 500,
              padding: "12px 24px",
              minWidth: "120px",
              "&:hover": {
                backgroundColor: "#218838",
              },
            }}
          />
          <Button
            variant="contained"
            label="Cancel"
            onClick={() => setOpenMakeNewFriendDialog(false)}
            sx={{
              backgroundColor: "#dc3545",
              color: "white",
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "16px",
              fontWeight: 500,
              padding: "12px 24px",
              minWidth: "100px",
              "&:hover": {
                backgroundColor: "#c82333",
              },
            }}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

function TransferTable({
  data,
  handleForward,
  handleReject,
  handleRemarks,
  handleAccept,
  cameFromFriendTransfer,
  cameFromMemberTransfer,
  onRefresh,
}) {
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openForwardModal, setOpenForwardModal] = useState(false);
  const [openAcceptModal, setOpenAcceptModal] = useState(false);
  const [openTransferModal, setOpenTransferModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);
  const { isHelpDesk, isHelpDeskAdmin } = useSelector(selectAllSIUsers);

  const toast = useContext(ToastAlertContext);
  const toggleAlert = () => setOpenAlert((prev) => !prev);
  const dispatch = useDispatch();
  const transferType = useSelector(
    (state) => state.dashboard.transferPendingType
  );

  const closeRejectModal = () => {
    setOpenRejectModal(false);
  };

  const closeForwardModal = () => {
    setOpenForwardModal(false);
  };

  const closeAcceptModal = () => {
    setOpenAcceptModal(false);
  };

  const closeTransferModal = () => {
    setOpenTransferModal(false);
  };

  const onCancel = (row) => {
    setSelectedRow(row);
    toggleAlert();
  };

  const onReject = (row) => {
    setSelectedRow(row);
    setOpenRejectModal(true);
  };

  const onForward = (row) => {
    setSelectedRow(row);
    setOpenForwardModal(true);
  };

  const onAccept = (row) => {
    setSelectedRow(row);
    setOpenAcceptModal(true);
  };

  const onSelectTransfer = (row) => {
    setSelectedRow(row);
    setOpenTransferModal(true);
  };

  const refreshTransferList = () => {
    if (cameFromMemberTransfer) {
      fetchMemberTransferData(dispatch, transferType);
    }
    if (cameFromFriendTransfer) {
      fetchFriendTransferData(dispatch, transferType);
    } else {
      fetchIntroductionData(dispatch, transferType);
    }
  };

  const handleCancel = async () => {
    try {
      if (cameFromFriendTransfer) {
        Friends.cancelFriend({
          id: selectedRow.transferId,
          friendId: selectedRow.friendId,
        });
      } else if (cameFromMemberTransfer) {
        Member.cancelMember({
          id: selectedRow.transferId,
          memberId: selectedRow.memberId,
        });
      } else {
        IntroductionForm.cancelIntro({
          data: {
            introductionIds: [selectedRow.introductionId],
          },
        });
      }
      toast.show("Cancelled Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        toggleAlert();
        refreshTransferList();
        if (isHelpDesk || isHelpDeskAdmin) {
          onRefresh();
        }
      }, 1000);
    } catch (error) {
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
      Sentry.captureException(error);
    }
  };

  const getIdLabel = () => {
    if (cameFromFriendTransfer) {
      return "FRIEND ID";
    }
    if (cameFromMemberTransfer) {
      return "MEMBER ID";
    }
  };

  const getDetailsLabel = () =>
    cameFromFriendTransfer
      ? "FRIEND DETAILS"
      : cameFromMemberTransfer
      ? "MEMBER DETAILS"
      : "INTRODUCTION DETAILS";

  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Box className="container">
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: "#7CC3EE" }}>
              <TableCell
                colSpan={
                  cameFromFriendTransfer || cameFromMemberTransfer ? 6 : 5
                }
              >
                <Box
                  style={{
                    ...styles.subHeadingStyle,
                    borderLeft: "1px solid rgba(94, 94, 94, 1)",
                  }}
                >
                  <Typography
                    variant="small"
                    weight={500}
                    sx={{ color: "black" }}
                  >
                    INITIATING ORGANISATIONAL STRUCTURE
                  </Typography>
                </Box>
              </TableCell>
              <TableCell
                style={{
                  paddingLeft: 0,
                }}
                colSpan={4}
              >
                <Box
                  style={{
                    ...styles.subHeadingStyle,
                    borderLeft: "1px solid rgba(94, 94, 94, 1)",
                  }}
                >
                  <Typography
                    variant="small"
                    weight={500}
                    sx={{ color: "black" }}
                  >
                    TARGET ORGANISATIONAL STRUCTURE
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
            <TableRow
              style={{
                backgroundColor: "#BAD9EC",
              }}
            >
              {(cameFromFriendTransfer || cameFromMemberTransfer) && (
                <TableCell item style={styles.column2}>
                  <Box
                    sx={{
                      borderLeft: "1px solid rgba(94, 94, 94, 1)",
                      paddingLeft: "0.6rem",
                    }}
                  >
                    <Typography
                      variant="mini"
                      weight={600}
                      sx={{ color: "black" }}
                    >
                      {getIdLabel()}
                    </Typography>
                  </Box>
                </TableCell>
              )}
              <TableCell item style={styles.column3}>
                <Box
                  sx={{
                    borderLeft: "1px solid rgba(94, 94, 94, 1)",
                    paddingLeft: "0.6rem",
                  }}
                >
                  <Typography
                    variant="mini"
                    weight={600}
                    sx={{ color: "black" }}
                  >
                    {getDetailsLabel()}
                  </Typography>
                </Box>
              </TableCell>
              {COLUMNS.map((headingObj, index) => {
                return (
                  <TableCell item style={headingObj.style}>
                    <Box
                      sx={{
                        borderLeft:
                          index !== 4 ? "1px solid rgba(94, 94, 94, 1)" : "",
                        paddingLeft: "0.6rem",
                      }}
                    >
                      <Typography
                        variant="mini"
                        weight={600}
                        sx={{ color: "black" }}
                      >
                        {headingObj.heading}
                      </Typography>
                    </Box>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& .MuiTypography-root": {
                fontSize: "14px",
                color: "#000000",
              },
              "tr:nth-child(even)": {
                backgroundColor: "#E8EDF4",
              },
            }}
          >
            {data?.map((rowData) => (
              <Row
                key={rowData.introductionId}
                rowData={rowData}
                handleForward={handleForward}
                handleReject={handleReject}
                handleRemarks={handleRemarks}
                handleCancel={handleCancel}
                handleAccept={handleAccept}
                cameFromFriendTransfer={cameFromFriendTransfer}
                cameFromMemberTransfer={cameFromMemberTransfer}
                selectedRow={selectedRow}
                onReject={onReject}
                onForward={onForward}
                onAccept={onAccept}
                onSelectTransfer={onSelectTransfer}
                onCancel={onCancel}
                onRefresh={onRefresh}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
      <RejectModal
        open={openRejectModal}
        refreshTransferList={refreshTransferList}
        onClose={closeRejectModal}
        selectedRow={selectedRow}
        cameFromFriendTransfer={cameFromFriendTransfer}
        cameFromMemberTransfer={cameFromMemberTransfer}
      />
      <ForwardModal
        open={openForwardModal}
        refreshTransferList={refreshTransferList}
        onClose={closeForwardModal}
        selectedRow={selectedRow}
        cameFromFriendTransfer={cameFromFriendTransfer}
        cameFromMemberTransfer={cameFromMemberTransfer}
        onRefresh={onRefresh}
      />
      <AcceptModal
        open={openAcceptModal}
        refreshTransferList={refreshTransferList}
        onClose={closeAcceptModal}
        selectedRow={selectedRow}
        cameFromFriendTransfer={cameFromFriendTransfer}
        cameFromMemberTransfer={cameFromMemberTransfer}
      />
      <TransferForm
        open={openTransferModal}
        onClose={closeTransferModal}
        selectedRow={selectedRow}
        cameFromFriendTransfer={cameFromFriendTransfer}
        cameFromMemberTransfer={cameFromMemberTransfer}
      />
      {isMobile ? (
        <AlertForMobile
          open={openAlert}
          onClose={toggleAlert}
          onSubmit={handleCancel}
          refreshTransferList={refreshTransferList}
        />
      ) : (
        <Alert
          open={openAlert}
          onClose={toggleAlert}
          onSubmit={handleCancel}
          refreshTransferList={refreshTransferList}
        />
      )}
    </Box>
  );
}

export default TransferTable;
